"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../utils/utils");

var _Button = _interopRequireDefault(require("./Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TooltipCoachmark = /*#__PURE__*/function (_Component) {
  _inherits(TooltipCoachmark, _Component);

  var _super = _createSuper(TooltipCoachmark);

  function TooltipCoachmark(props) {
    var _this;

    _classCallCheck(this, TooltipCoachmark);

    _this = _super.call(this, props);
    _this.myRef = /*#__PURE__*/_react["default"].createRef();
    _this.state = _objectSpread({
      state: props.state || "hide",
      defaultEvent: props.defaultEvent,
      x: 0,
      y: 0,
      currentStep: 1,
      lastStep: false,
      pagination: ""
    }, props.restOfState);
    _this.getContext = _this.getContext.bind(_assertThisInitialized(_this));
    _this.updateTooltip = _this.updateTooltip.bind(_assertThisInitialized(_this));
    _this.setEvent = _this.setEvent.bind(_assertThisInitialized(_this));
    _this.removeEvent = _this.removeEvent.bind(_assertThisInitialized(_this));
    _this.event = _this.event.bind(_assertThisInitialized(_this));
    _this.isTargetTooltip = _this.isTargetTooltip.bind(_assertThisInitialized(_this));
    _this.showStep = _this.showStep.bind(_assertThisInitialized(_this));
    _this.nextPrev = _this.nextPrev.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TooltipCoachmark, [{
    key: "show",
    value: function show() {
      var onlyEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.state.defaultEvent) {
        if (onlyEvent && this.state.state === "show" || !onlyEvent && this.state.state === "hide") {
          document.addEventListener("click", this.isTargetTooltip, false);
        }
      }

      if (!onlyEvent) {
        this.setState({
          state: "show"
        });
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var onlyEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.state.defaultEvent) {
        if (onlyEvent && this.state.state === "hide" || !onlyEvent && this.state.state === "show") {
          document.removeEventListener("click", this.isTargetTooltip, false);
        }
      }

      if (!onlyEvent) {
        this.setState({
          state: "hide"
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var steps = false;

      if (this.props.type === 'coachmark-text-steps') {
        steps = true;
        this.showStep(this.state.currentStep); // Display the current step
      }

      this.updateTooltip(steps);

      if (!this.props.isControlled) {
        this.setEvent();
      }

      if (this.state.state === "show") {
        this.show(true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.defaultEvent) {
        var context;

        if (this.props.context) {
          context = this.getContext();
        } else {
          context = this.myRef.current.parentElement;
        }

        context.removeEventListener("mouseenter", this.event);
        context.removeEventListener("mouseleave", this.event);
      } else {
        document.removeEventListener("click", this.isTargetTooltip, false);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.state === "hide" && this.state.state === "show") {
        var steps = false;

        if (this.props.type === 'coachmark-text-steps') {
          steps = true;
        }

        this.updateTooltip(steps);
      }

      if (this.props.type === 'coachmark-text-steps' && prevState.currentStep != this.state.currentStep) {
        this.updateTooltip(true);
      }

      if (prevState.state !== this.state.state) {
        if (this.state.state === "show") {
          this.show(true);
        } else {
          this.hide(true);
        }
      }
    }
  }, {
    key: "isTargetTooltip",
    value: function isTargetTooltip(event) {
      if (!(0, _utils.Contains)(this.myRef.current, event.target)) {
        this.hide();
      }
    }
  }, {
    key: "setEvent",
    value: function setEvent() {
      if (!this.state.defaultEvent) {
        if (this.state.state === "show") {
          document.addEventListener("click", this.isTargetTooltip, false);
        }

        return;
      }

      var context;

      if (this.props.context) {
        context = this.getContext();
      } else {
        context = this.myRef.current.parentElement;
      }

      context.addEventListener("mouseenter", this.event);
      context.addEventListener("mouseleave", this.event);
    }
  }, {
    key: "removeEvent",
    value: function removeEvent() {
      if (!this.state.defaultEvent) {
        document.removeEventListener("click", this.isTargetTooltip, false);
        return;
      }

      var context;

      if (this.props.context) {
        context = this.getContext();
      } else {
        context = this.myRef.current.parentElement;
      }

      context.removeEventListener("mouseenter", this.event);
      context.removeEventListener("mouseleave", this.event);
    }
  }, {
    key: "event",
    value: function event(_event) {
      var steps = false;

      if (this.props.type === 'coachmark-text-steps') {
        steps = true;
      }

      switch (_event.type) {
        case "mouseenter":
          this.updateTooltip(steps);
          this.setState({
            state: "show"
          });
          break;

        case "mouseleave":
          this.setState({
            state: "hide"
          });
          break;
      }
    }
  }, {
    key: "getContext",
    value: function getContext() {
      var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var context;

      if (steps) {
        var currentStep = this.state.currentStep;

        if (this.props.context[currentStep - 1].indexOf('.') === 0) {
          context = document.getElementsByClassName(this.props.context[currentStep - 1].substr(1))[0];
        } else {
          context = document.getElementById(this.props.context[currentStep - 1].substr(1));
        }
      } else {
        if (this.props.context.indexOf('.') === 0) {
          context = document.getElementsByClassName(this.props.context.substr(1))[0];
        } else {
          context = document.getElementById(this.props.context.substr(1));
        }
      }

      return context;
    }
  }, {
    key: "updateTooltip",
    value: function updateTooltip() {
      var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var tooltip = this.myRef.current;
      var x, y;
      var currentStep = this.state.currentStep;

      if (steps && this.props.type === 'coachmark-text-steps') {
        if (this.props.context[currentStep - 1] != "") {
          var context = this.getContext(true);
          var position = this.props.position[currentStep - 1] || "top";

          switch (position) {
            case "top":
              if (this.props.arrowPosition[currentStep - 1] === "arrow-left") {
                x = context.offsetLeft + context.offsetWidth / 2 - tooltip.offsetWidth * 9 / 100;
              } else if (this.props.arrowPosition[currentStep - 1] === "arrow-right") {
                x = context.offsetLeft + context.offsetWidth / 2 - tooltip.offsetWidth * 92 / 100;
              }

              y = context.offsetTop - tooltip.offsetHeight - 5;
              break;

            case "right":
              x = context.offsetLeft + context.offsetWidth + 5;

              if (this.props.arrowPosition[currentStep - 1] === "arrow-top") {
                y = context.offsetTop + context.offsetHeight / 2 - tooltip.offsetHeight * 12 / 100;
              } else if (this.props.arrowPosition[currentStep - 1] === "arrow-bottom") {
                y = context.offsetTop + context.offsetHeight / 2 - tooltip.offsetHeight * 86 / 100;
              }

              break;

            case "bottom":
              if (this.props.arrowPosition[currentStep - 1] === "arrow-left") {
                x = context.offsetLeft + context.offsetWidth / 2 - tooltip.offsetWidth * 9 / 100;
              } else if (this.props.arrowPosition[currentStep - 1] === "arrow-right") {
                x = context.offsetLeft + context.offsetWidth / 2 - tooltip.offsetWidth * 92 / 100;
              }

              y = context.offsetTop + context.offsetHeight + 5;
              break;

            case "left":
              x = context.offsetLeft - tooltip.offsetWidth - 5;

              if (this.props.arrowPosition[currentStep - 1] === "arrow-top") {
                y = context.offsetTop + context.offsetHeight / 2 - tooltip.offsetHeight * 12 / 100;
              } else if (this.props.arrowPosition[currentStep - 1] === "arrow-bottom") {
                y = context.offsetTop + context.offsetHeight / 2 - tooltip.offsetHeight * 86 / 100;
              }

              break;
          }
        }
      } else {
        if (this.props.context != "") {
          var _context = this.getContext();

          var _position = this.props.position || "top";

          switch (_position) {
            case "top":
              if (this.props.type === "coachmark-text") {
                if (this.props.arrowPosition === "arrow-left") {
                  x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth * 9 / 100;
                } else if (this.props.arrowPosition === "arrow-right") {
                  x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth * 92 / 100;
                }
              } else {
                x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth / 2;
              }

              y = _context.offsetTop - tooltip.offsetHeight - 5;
              break;

            case "right":
              x = _context.offsetLeft + _context.offsetWidth + 5;

              if (this.props.type === "coachmark-text") {
                if (this.props.arrowPosition === "arrow-top") {
                  y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight * 12 / 100;
                } else if (this.props.arrowPosition === "arrow-bottom") {
                  y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight * 86 / 100;
                }
              } else {
                y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight / 2;
              }

              break;

            case "bottom":
              if (this.props.type === "coachmark-text") {
                if (this.props.arrowPosition === "arrow-left") {
                  x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth * 9 / 100;
                } else if (this.props.arrowPosition === "arrow-right") {
                  x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth * 92 / 100;
                }
              } else {
                x = _context.offsetLeft + _context.offsetWidth / 2 - tooltip.offsetWidth / 2;
              }

              y = _context.offsetTop + _context.offsetHeight + 5;
              break;

            case "left":
              x = _context.offsetLeft - tooltip.offsetWidth - 5;

              if (this.props.type === "coachmark-text") {
                if (this.props.arrowPosition === "arrow-top") {
                  y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight * 12 / 100;
                } else if (this.props.arrowPosition === "arrow-bottom") {
                  y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight * 86 / 100;
                }
              } else {
                y = _context.offsetTop + _context.offsetHeight / 2 - tooltip.offsetHeight / 2;
              }

              break;
          }
        }
      }

      this.setState({
        x: x + this.props.adjustedXY.x,
        y: y + this.props.adjustedXY.y
      });
    }
  }, {
    key: "showStep",
    value: function showStep(n) {
      if (n == 1) {
        document.getElementById("prevBtn").style.display = "none";
      } else {
        document.getElementById("prevBtn").style.display = "inline";
      }

      this.setState({
        pagination: n + " of " + this.props.countSteps
      });
    }
  }, {
    key: "nextPrev",
    value: function nextPrev(n) {
      // Increase or decrease the current step by 1:
      var currentStep = this.state.currentStep + n;

      if (currentStep <= this.props.countSteps) {
        this.setState({
          currentStep: currentStep,
          last: false
        });
        this.updateTooltip(true);
        this.showStep(currentStep);
      } // if you have reached the last step


      if (currentStep >= this.props.countSteps) {
        this.setState({
          last: true
        });
        this.updateTooltip(true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var style = _objectSpread({}, this.props.style);

      var currentStep = this.state.currentStep;
      var position = 'top';
      var arrowPosition = '';

      if (this.props.type === 'coachmark-text-steps') {
        position = this.props.position[currentStep - 1] || "top";
        arrowPosition = this.props.arrowPosition[currentStep - 1] || "";
      } else {
        position = this.props.position || "top";
        arrowPosition = this.props.arrowPosition || "";
      }

      if (this.props.context) {
        style.top = this.state.y;
        style.left = this.state.x;
        style = _objectSpread(_objectSpread({}, style), this.props.style);
      }

      var type = this.props.type || "tooltip";
      var color = this.props.color;
      var containerCss = (0, _classnames["default"])("fade", type, position, arrowPosition, color, {
        "in": this.state.state === "show",
        "hide": this.state.state === "hide",
        "noContext": !this.props.context,
        "transform": this.props.transform && this.props.type === "coachmark-icon"
      }, this.props.className);

      if (this.props.type === 'coachmark-text-steps') {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "tooltipCoachmark-component"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.myRef,
          className: containerCss,
          style: style
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "content"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-header"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-title"
        }, this.props.title[currentStep - 1]), this.props.type === 'coachmark-text-steps' && /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-pagination"
        }, this.state.pagination)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-text-content"
        }, this.props.text[currentStep - 1]), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-footer"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-link"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: this.props.linkUrl[currentStep - 1]
        }, this.props.linkLabel[currentStep - 1])), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-nav"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-prev"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          id: "prevBtn",
          onClick: function onClick() {
            return _this2.nextPrev(-1);
          }
        }, this.props.previousLabel)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-button",
          id: "nextBtn"
        }, this.state.last ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          radius: "round",
          colorTheme: "teal",
          shapeStyle: "fill",
          size: "small",
          onClick: this.props.onClick
        }, this.props.buttonLabel[currentStep - 1]) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          radius: "round",
          colorTheme: "teal",
          shapeStyle: "fill",
          size: "small",
          onClick: function onClick() {
            _this2.nextPrev(1);
          }
        }, this.props.buttonLabel[currentStep - 1])))))));
      } else if (this.props.type === 'coachmark-text') {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "tooltipCoachmark-component"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.myRef,
          className: containerCss,
          style: style
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "content"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-title"
        }, this.props.title), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-text-content"
        }, this.props.text), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-footer"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-link"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: this.props.linkUrl
        }, this.props.linkLabel)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "coachmark-button"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          radius: "round",
          colorTheme: "teal",
          shapeStyle: "fill",
          size: "small",
          onClick: this.props.onClick
        }, this.props.buttonLabel))))));
      } else {
        if (this.props.content) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "tooltipCoachmark-component"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            ref: this.myRef,
            className: containerCss,
            style: style
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "content"
          }, this.props.content)));
        } else {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "tooltipCoachmark-component"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            ref: this.myRef,
            className: containerCss,
            style: style
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "content"
          }, this.props.children)));
        }
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.isControlled && nextProps.state != null && nextProps.state !== state.state) {
        if (nextProps.state === "show") {
          return {
            state: "show"
          };
        } else {
          return {
            state: "hide"
          };
        }
      }

      return null;
    }
  }]);

  return TooltipCoachmark;
}(_react.Component);

TooltipCoachmark.propTypes = {
  defaultEvent: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  state: _propTypes["default"].oneOf(["show", "hide"]),
  type: _propTypes["default"].oneOf(["tooltip", "tooltip-text", "coachmark-icon", "coachmark-text", "coachmark-text-steps"]),
  position: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["top", "right", "bottom", "left"]), _propTypes["default"].array]),
  arrowPosition: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["arrow-top", "arrow-right", "arrow-bottom", "arrow-left"]), _propTypes["default"].array]),
  context: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  transform: _propTypes["default"].bool,
  text: _propTypes["default"].any,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  linkLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  linkUrl: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  onClick: _propTypes["default"].func,
  countSteps: _propTypes["default"].number,
  color: _propTypes["default"].oneOf(["grey", "red", "coal", "onyx", "white"]),
  previousLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  buttonLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  adjustedXY: _propTypes["default"].object,
  isControlled: _propTypes["default"].bool
};
TooltipCoachmark.defaultProps = {
  defaultEvent: false,
  color: "grey",
  type: "tooltip",
  position: "top",
  arrowPosition: "arrow-left",
  onClick: function onClick() {},
  previousLabel: "Previous",
  adjustedXY: {
    'x': 0,
    'y': 0
  },
  isControlled: false,
  context: ""
};
var _default = TooltipCoachmark;
exports["default"] = _default;